import { FormattedMessage } from 'react-intl';

import { BooleanPropertyToggle } from '../boolean-property-toggle';
import { messages } from './messages';

import type { TextWidget, WidgetPropertyDefinition, WidgetPropertyInput } from '../../../config';

const IsItalic = ({ widget, updateWidget, ...rest }: WidgetPropertyInput<TextWidget>) => {
  return <BooleanPropertyToggle updateWidget={(value) => updateWidget({ isItalic: value })} value={widget.isItalic} {...rest} />;
};

export const IsItalicProperty: WidgetPropertyDefinition<TextWidget> = {
  id: 'is-italic',
  label: <FormattedMessage {...messages.label} />,
  Component: IsItalic,
};
